import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { client } from "../config/prismic";

const Cfp = () => {
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("call_for_paper");
      setSessions(response.results);
    };
    fetchData();
  }, []);

  if (!sessions) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  // Function to render text with spans
  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0;
    const elements = [];

    spans.forEach((span) => {
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>
            {text.slice(span.start, span.end)}
          </strong>,
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            {text.slice(span.start, span.end)}
          </a>,
        );
      }

      lastIndex = span.end;
    });

    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };

  return (
    <div>
      <Header page={true} />
      <Cta title="Call for Papers" />

      <div className="container my-12 md:my-20">
        <div className="card shadow-lg">
          <div className="card-body space-y-4">
            {sessions.map((session) => (
              <div key={session.id}>
                {/* Description */}
                {session.data.description.map((desc, index) => (
                  <p
                    key={index}
                    className="card-text text-justify mb-4 leading-relaxed"
                  >
                    {renderTextWithSpans(desc.text, desc.spans)}
                  </p>
                ))}

                {/* Dark Text / Tracks */}
                {session.data.dark_text.map((darkText, index) => (
                  <h4 key={index} className="text-xl font-semibold mt-8 mb-4">
                    {renderTextWithSpans(darkText.text, darkText.spans)}
                  </h4>
                ))}

                {/* Instructions */}
                <h3 className="text-center mt-10 pt-4 text-2xl font-bold">
                  Instructions For Authors
                </h3>

                <ul className="mt-4">
                  {session.data.instructions.map((instruction, index) => (
                    <li
                      key={index}
                      className="text-justify mb-3 leading-relaxed"
                    >
                      {renderTextWithSpans(instruction.text, instruction.spans)}
                    </li>
                  ))}
                </ul>

                {/* Copyright */}
                <h3 className="text-center mt-10 pt-4 text-2xl font-bold">
                  Copy Right Form:
                </h3>

                <ul className="mt-4">
                  {session.data.copyright.map((copyRight, index) => (
                    <li
                      key={index}
                      className="text-justify mb-3 leading-relaxed"
                    >
                      {renderTextWithSpans(copyRight.text, copyRight.spans)}
                    </li>
                  ))}
                </ul>

                {/* Useful Links */}
                <p className="mt-8 font-semibold text-lg">Useful Links:</p>

                {session.data.links.map((copyRight, index) => (
                  <p key={index} className="text-justify mb-3 leading-relaxed">
                    {renderTextWithSpans(copyRight.text, copyRight.spans)}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Cfp;
